import * as React from 'react';

export const useMessageText = (text?: string | null) => {
  return React.useMemo(() => {
    if (!text) {
      return null;
    }

    const trimmedText = text.trim();

    if (!trimmedText) {
      return null;
    }

    return trimmedText.split('\n').map((item, key) => (
      <span key={`text-${key}`}>
        {item}
        <br />
      </span>
    ));
  }, [text]);
};
